import {
  Home,
  Gamepad2,
  Library,
  PenTool,
  LogOut,
  Search,
  Edit,
  Trash2,
  Plus,
  Minus,
  Save,
  X,
  Check,
  ArrowLeft,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  GripVertical,
  BookOpen,
  FileText,
  Image,
  Loader2,
  AlertTriangle,
  Info,
  CheckCircle,
  AlertCircle,
  Sun,
  Moon,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Code,
  SquareCode,
  Link,
  Unlink,
  ExternalLink,
  List,
  ListOrdered,
  ListTodo,
  Quote,
  Table,
  BetweenHorizontalEnd,
  BetweenVerticalEnd,
  Rows3,
  Columns3,
  PanelTop,
  SeparatorHorizontal,
  Pilcrow,
  Heading1,
  Heading2,
  Heading3,
  Undo2,
  Redo2,
  MoreHorizontal,
  StickyNote,
} from 'lucide-react';

import { IconMappings } from '../types';

export const lucideIconMappings: IconMappings = {
  // Navigation icons
  home: Home,
  games: Gamepad2,
  collection: Library,
  journal: PenTool,
  logout: LogOut,
  search: Search,

  // Action icons
  edit: Edit,
  delete: Trash2,
  add: Plus,
  remove: Minus,
  save: Save,
  cancel: X,
  check: Check,
  close: X,

  // UI Control icons
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  chevronDown: ChevronDown,
  dragHandle: GripVertical,
  more: MoreHorizontal,
  note: StickyNote,

  // Content icons
  gamepad: Gamepad2,
  book: BookOpen,
  pen: PenTool,
  file: FileText,
  image: Image,

  // Status icons
  loading: Loader2,
  error: AlertTriangle,
  warning: AlertTriangle,
  info: Info,
  checkCircle: CheckCircle,
  alertCircle: AlertCircle,

  // Theme icons
  sun: Sun,
  moon: Moon,

  // Rich text editor icons
  bold: Bold,
  italic: Italic,
  underline: Underline,
  strikethrough: Strikethrough,
  code: Code,
  codeBlock: SquareCode,
  link: Link,
  unlink: Unlink,
  externalLink: ExternalLink,
  listBullet: List,
  listOrdered: ListOrdered,
  listTask: ListTodo,
  quote: Quote,
  table: Table,
  tableAddRow: BetweenHorizontalEnd,
  tableAddColumn: BetweenVerticalEnd,
  tableDeleteRow: Rows3,
  tableDeleteColumn: Columns3,
  tableHeaderRow: PanelTop,
  horizontalRule: SeparatorHorizontal,
  paragraph: Pilcrow,
  heading1: Heading1,
  heading2: Heading2,
  heading3: Heading3,
  undo: Undo2,
  redo: Redo2,
};
